export default __webpack_public_path__ + "static/media/High Quality Protoype.fe0eb61d.svg";